/**
 * 根据版本code获取版本描述
 * @param {*} itemCode 
 * @returns 
 */
export function getItemCodeDesc(itemCode) {
  if(itemCode == null) return "初级版";
  else if(itemCode ==="FW_GOODS-1859823-v3") return "中级版";
  else if(itemCode == "FW_GOODS-1859823-v2") return "高级版";
  else return "基础版";
}

export default {
  getItemCodeDesc
}




// WEBPACK FOOTER //
// ./src/utils/tools.js